import { cn } from '@utils';
import * as React from 'react';
import type { IconTextLineProps } from './icon-text-line.type';

export const IconTextLine: React.FC<IconTextLineProps> = ({ icon, centered = false, className = '', children, childrenClassName = '' }) => (
	<div data-aid="Icon-Text-Line" className={cn('flex flex-col', className)}>
		<div className={cn('flex gap-1 min-w-0', centered ? 'items-center' : 'items-start')}>
			<div className="shrink-0">{icon}</div>
			<div className={cn('grow', childrenClassName)}>{children}</div>
		</div>
	</div>
);
